export const getActiveItemIndex = (
  itemIdFromUpdateTourProgress: string,
  tourDataFromUpdateTourProgress: any[]
) => {
  const itemOrderInFirebase = tourDataFromUpdateTourProgress.find(
    (item) => item.id === itemIdFromUpdateTourProgress
  )?.order;

  console.log(
    'received itemOrderInFirebase: ',
    itemOrderInFirebase,
    'itemOrderInFirebase + 1: ',
    itemOrderInFirebase + 1
  );

  return itemOrderInFirebase + 1;
};
